// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundPanelHeader__header-container-c9175d {
  display: flex;
  margin: 16px 16px 0 16px;
  align-items: center;
}

.BackgroundPanelHeader__title-a2ea31 {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--addition-50);
}

.BackgroundPanelHeader__closeButton-a8aa9c {
  margin-inline-start: auto;
}

.BackgroundPanelHeader__backButton-b97d98 {
  margin-inline-end: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/AnimatedBackgroundPanel/components/BackgroundPanelHeader/BackgroundPanelHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,uBAAA;AACF","sourcesContent":[".header-container {\n  display: flex;\n  margin: 16px 16px 0 16px;\n  align-items: center;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--addition-50);\n}\n\n.closeButton {\n  margin-inline-start: auto;\n}\n\n.backButton {\n  margin-inline-end: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header-container": `BackgroundPanelHeader__header-container-c9175d`,
	"headerContainer": `BackgroundPanelHeader__header-container-c9175d`,
	"title": `BackgroundPanelHeader__title-a2ea31`,
	"closeButton": `BackgroundPanelHeader__closeButton-a8aa9c`,
	"backButton": `BackgroundPanelHeader__backButton-b97d98`
};
module.exports = ___CSS_LOADER_EXPORT___;
